export class Tsk1030Class {

    ChecklistId:number;
    tsk1030History: Tsk1030Class;
    ChecklistCode:string;
    ChecklistName:string;
    Tsk1030List: Array<Tsk1030Class> = [];
    MdfdBy: number;
    MdfdOn: Date;
}
